/* <ProductOutcomes />
   ----------------------------------------------------------
   Compact horizontal stat-rail rendering of each product's
   outcome metrics — a single row of "big metric + tiny
   uppercase label", no card backgrounds, no section header.
   Mirrors the dense stat-rail treatment used inside the
   product hero stage. */
export default function ProductOutcomes({ product }) {
  const outcomes = product.outcomes || [];
  if (outcomes.length === 0) return null;
  return (
    <section className="product-outcomes-rail">
      {outcomes.map((o, i) => (
        <div key={i} className="product-outcome-stat">
          <div className="product-outcome-stat__metric">{o.metric}</div>
          <div className="product-outcome-stat__label">{o.label}</div>
        </div>
      ))}
    </section>
  );
}
